import { api } from "@/lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Ouvre une ressource protégée (facture, devis, fichier) dans un nouvel onglet
 * via un jeton court à usage unique (60 s). Aucun JWT n'apparaît jamais dans
 * l'URL, les journaux serveur ou les en-têtes Referer.
 */
export async function openProtectedResource(resource, resourceId, pathBuilder) {
  try {
    const { data } = await api.post("/downloads/token", {
      resource,
      resource_id: resourceId,
    });
    const url = `${API}${pathBuilder(resourceId)}?dt=${encodeURIComponent(data.token)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  } catch (e) {
    const msg = e?.response?.data?.detail || "Impossible d'ouvrir la ressource";
    const { toast } = await import("sonner");
    toast.error(msg);
  }
}

export const openInvoicePdf = (id) =>
  openProtectedResource("invoice", id, (i) => `/invoices/${i}.pdf`);
export const openQuotePdf = (id) =>
  openProtectedResource("quote", id, (i) => `/orders/${i}/quote.pdf`);
export const openFile = (id) =>
  openProtectedResource("file", id, (i) => `/files/${i}`);
